import { http } from '../../../common/http/client';
import { type Page, toPage } from '../../../common/helpers/linkHeaderHelper';
import type { Project } from './project';
import type { ProjectsPrResponse } from './pr';

export default class ProjectClient {
  fetchAll(
    page: number,
    keyword: string | null,
    order: string | null,
    signal?: AbortSignal,
  ): Promise<Page<Project>> {
    return http
      .request<Project[]>('/api/v1/projects/stagings.json', {
        params: {
          page: page,
          keyword: keyword,
          order: order,
        },
        signal: signal,
      })
      .then(toPage);
  }

  // エンジェル税制対象の募集中案件を先頭から limit 件だけ取る（エンジェル税制シミュレーターの結果下の一覧）。
  // angel_tax=1 は API 側の絞り込み（#17537）。並び順は募集ページ一覧の新着順と同じ。
  fetchAngelTax(limit: number, signal?: AbortSignal): Promise<Project[]> {
    return http.get<Project[]>('/api/v1/projects/stagings.json', {
      params: {
        angel_tax: 1,
        per_page: limit,
        order: 'in_progress',
      },
      signal: signal,
    });
  }

  fetchPr(signal?: AbortSignal): Promise<ProjectsPrResponse> {
    return http.get<ProjectsPrResponse>('/api/v1/projects/pr.json', {
      signal: signal,
    });
  }
}
